<template>
  <v-container>
    <v-card :loading="loading" class="mx-auto my-12" max-width="374" v-if="!insurance_data.hasOwnProperty('message')" >
      <v-img
        :src="showImage(insurance_data.image)"
        height="400px" cover
      >
      <template v-slot:placeholder>
        <v-row
          class="fill-height ma-0"
          align="center"
          justify="center"
        >
          <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
        </v-row>
      </template>
        <v-layout column fill-height>
          <v-card-title class="white--text pl-5 pt-5">
            <div v-if="insurance_data.employee_no" >Staff</div>
            <div v-if="insurance_data.employee_id" >Dependent</div>

            <v-spacer></v-spacer>
          </v-card-title>

          <v-spacer></v-spacer>

          <v-card-title class="white--text pl-5 pt-5">
            <div class="display-1 pl-1 pt-5">{{ insurance_data.firstname }} {{ insurance_data.lastname }}</div>
          </v-card-title>
        </v-layout>
      </v-img>

      <v-card-title> Basic Details</v-card-title>

      <v-card-text>
        <v-list class="transparent">
          <v-list-item>
            <v-list-item-title>Insurance Type</v-list-item-title>
              <v-list-item-subtitle v-if="insurance_data.employee_no" class="text-right">
                Staff
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="insurance_data.employee_id" class="text-right">
                Dependent
              </v-list-item-subtitle>
          </v-list-item>

          <v-list-item v-if="insurance_data.department_id">
            <v-list-item-title>Department</v-list-item-title>

            <v-list-item-subtitle class="text-right">
              {{insurance_data.dept_name}}
            </v-list-item-subtitle>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-divider class="mx-4"></v-divider>

      <v-card-title>Insurance Details</v-card-title>

      <v-card-text>
        <v-list class="transparent">
          <v-list-item>
            <v-list-item-title>Insurance No.</v-list-item-title>

            <v-list-item-subtitle class="text-right">
              {{ insurance_data.insurance_no }}
            </v-list-item-subtitle>
          </v-list-item>
           <v-list-item>
            <v-list-item-title>Issued Date</v-list-item-title>
            <v-list-item-subtitle class="text-right">
              {{insurance_data.insurance_iss_date | formatShortDate}}
            </v-list-item-subtitle>
          </v-list-item>
           </v-list-item>
           <v-list-item>
            <v-list-item-title>Expiry Date</v-list-item-title>
            <v-list-item-subtitle class="text-right">
              {{ insurance_data.insurance_exp_date | formatShortDate }}
            </v-list-item-subtitle>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Status</v-list-item-title>
            <v-list-item-subtitle class="text-right" >
              <div v-if="insurance_data.service_status || insurance_data.insurance_status">
                VALID
              </div>
              <div v-else>INVALID</div>
            </v-list-item-subtitle>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-card-actions>
        <v-flex xs-auto sm-auto text-xs-center>
          <div>
            <v-btn block color="primary" dark @click="logVisit(insurance_data)">
              Verified!
            </v-btn>
          </div>
          <div>
            <v-btn block color="blue darken-1" text @click="close"
              >Close/Cancel</v-btn
            >
          </div>
        </v-flex>
      </v-card-actions>
    </v-card>

    <v-card v-if="!invalid" class="mx-auto" max-width="344" color="#385F73" dark>
      <v-card-text>
        Invalid Card Details. Please contact Gambia Ports Authority, if you think this is a mistake.
      </v-card-text>

      <v-card-actions>
        <v-flex xs-auto sm-auto text-xs-center>
          <div>
            <v-btn dark block color="blue darken-1" @click="close">Close</v-btn>
          </div>
        </v-flex>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { EventBus } from "../main";
import ModuleAccessService from "@/services/access-module.service";
import ImageService from "@/services/image.service";
import moment from "moment";
import {
  VARIFIED_CARD
} from "@/store/modules/actions.type";

export default {
  name: "search-result",
  props: ["insurance_data"],
  data: () => ({
    invalid: true,
    loading: false,
    current_date: moment().format("YYYY-MM-DD"),
    insurance: []
  }),
  components: {},
  created(){
    
    //console.log(this.insurance_data)
    if(this.insurance_data.hasOwnProperty("message")){
      this.invalid = false;
    }
  },
  methods: {
    close() {
      EventBus.$emit("closeChildComponent", true);
    },
    submit(slug="", data){

        this.$swal
        .fire({
          title: "Record Visit?",
          type: "info",
          showCancelButton: true,
          confirmButtonText: "Yes"
        })
        .then(result => {
          /* Read more about isConfirmed, isDenied below */
          if (result && result.dismiss != "cancel") {
           // console.log("record...")
            if (data) {
              this.$store
                .dispatch(VARIFIED_CARD, { slug, data })
                .then(res => {
                  this.$swal.fire(
                    `${res.message.success}`,
                    "",
                    "success"
                  );
                  this.close();
                })
                .catch(({ response }) => {
                  if (response !== undefined) {
                    this.errors = response.data.error;
                    this.$swal.fire(this.errors, "", "error");
                  }
                });
            }
          }
        });
      /* this.$store
          .dispatch(VARIFIED_CARD, { slug, data })
          .then( res => {
            this.$noty.success(res.message.success);
            this.close();
          })
          .catch(({ response }) => {
            this.errors = response.data;
             this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: this.errors.error });
          });*/
    },
    showImage(name){
      return ImageService.getPublicImageUrl() + name;
      //return ImageService.getImage(name);
    },
    logVisit(item){
      let data = {
        insurance_no : item.insurance_no,
        clinic_id : ModuleAccessService.getClinicID(),
        user_id : ModuleAccessService.getUserID(),
        visit_date :  moment().format("YYYY-MM-DD HH:mm:ss"),
        date: this.current_date
      }
      // console.log("log visit")
      //console.log(data)
      this.submit("", data)
    }
  }
};
</script>
